<template>
<div class="OtherError">
    <h1>アクセスしたページを表示できませんでした</h1>
    <div class="description">
        時間をおいて<TextButton text="再読み込み" size="lg" @click="reload" inline />をお試しください。それでも解決しない場合はお問合せください。
    </div>
    <Button text="お問合せフォーム" mode="primary" width="100%" @click="contact" />
    <div>
        <div class="emailDescription">※お問合せフォームが表示されない場合は、以下のメールアドレスまで直接ご連絡ください。</div>
        <TextLink to="mailto:support-cs@ka-nabell.com" text="support-cs@ka-nabell.com" inline />
    </div>
</div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { Button, TextLink, TextButton } from '@ka-nabellinc/ka-nabell-ui'
import { useProfileWeb } from '@/composables/useProfileWeb'
export default defineNuxtComponent({
components: {
    Button,
    TextLink,
    TextButton,
},
setup(){
    useHead({
        title: 'その他エラー'
    })

    const { myPageLink } = useProfileWeb()

    const contact = () => {
        window.location.href = `${myPageLink.value}/contact`
    }
    const reload = () => {
        window.location.reload()
    }
    return {
        contact,
        reload
    }
}
})
</script>

<style scoped>
.OtherError {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px
}
.description {
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0.14px;
}
.emailDescription {
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0.12px;
}
</style>